<template>
  <div>
    <div>
      <span v-if="type == 'time'">
        <el-tag
          v-show="!disabled"
          style="margin-right: 10px;"
          v-for="(item, i) in time"
          :key="item"
          closable
          @close="handleClose(item, i)"
        >
          {{ item.time }}
        </el-tag>
        <el-tag v-show="disabled" style="margin-right: 10px;" v-for="item in time" :key="item">
          {{ item.time }}
        </el-tag>
      </span>
      <div class="add" v-if="type == 'time'">
        <el-popover class="box-card" v-model="show">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="box">
              <div class="select">
                <div style="text-align: center;">
                  <h3>开始时间</h3>
                  <el-form-item prop="startTime">
                    <el-select
                      v-model="ruleForm.startTime"
                      @change="getEndOption"
                      placeholder="请选择开始时间"
                    >
                      <el-option
                        style="text-aline: center;"
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div style="margin-left: 30px; text-align: center;">
                  <h3>结束时间</h3>
                  <el-form-item prop="endTime">
                    <el-select
                      v-model="ruleForm.endTime"
                      @change="$forceUpdate()"
                      no-data-text="请先选择开始时间"
                      placeholder="请选择结束时间"
                    >
                      <el-option
                        v-for="item in endOptions"
                        :key="item.value + 25"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.disabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="button">
                <el-button type="primary" @click="addTime('ruleForm')">确定</el-button>
                <el-button type="info" @click="show = false">取消</el-button>
              </div>
            </div>
          </el-form>
          <el-tag slot="reference" type="danger" v-show="!disabled">+</el-tag>
        </el-popover>
      </div>

      <span v-if="type == 'people'">
        <el-tag
          v-show="!disabled"
          style="margin-right: 10px;"
          v-for="(item, i) in peoples"
          :key="item[dictKey]"
          closable
          @close="handleCloseGroup(item, i, item[dictValue])"
        >
          {{ item[dictKey] }}
        </el-tag>
        <el-tag v-show="disabled" style="margin-right: 10px;" v-for="item in time" :key="item">
          {{ item[dictKey] }}
        </el-tag>
      </span>
      <div class="add" style="width: 200px;" v-if="type == 'people'">
        <el-popover class="box-card" style="position: relative; width: 200px;" v-model="show">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="box">
              <div class="select-people">
                <div style="text-align: center;">
                  <h3>请选择</h3>
                  <el-form-item prop="group">
                    <el-select
                      multiple="true"
                      filterable="true"
                      v-model="ruleForm.group"
                      @change="changePeople"
                      placeholder="请选择"
                    >
                      <el-option
                        style="text-aline: center;"
                        v-for="item in dictData"
                        :key="item[dictValue]"
                        :label="item[dictKey]"
                        :value="item[dictValue]"
                        :disabled="item.disabled"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
          <el-tag slot="reference" type="danger" v-show="!disabled">+</el-tag>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
let dictTime = [
  {
    label: '0点',
    value: 0,
    disabled: false,
  },
  {
    label: '1点',
    value: 1,
    disabled: false,
  },
  {
    label: '2点',
    value: 2,
    disabled: false,
  },
  {
    label: '3点',
    value: 3,
    disabled: false,
  },
  {
    label: '4点',
    value: 4,
    disabled: false,
  },
  {
    label: '5点',
    value: 5,
    disabled: false,
  },
  {
    label: '6点',
    value: 6,
    disabled: false,
  },
  {
    label: '7点',
    value: 7,
    disabled: false,
  },
  {
    label: '8点',
    value: 8,
    disabled: false,
  },
  {
    label: '9点',
    value: 9,
    disabled: false,
  },
  {
    label: '10点',
    value: 10,
    disabled: false,
  },
  {
    label: '11点',
    value: 11,
    disabled: false,
  },
  {
    label: '12点',
    value: 12,
    disabled: false,
  },
  {
    label: '13点',
    value: 13,
    disabled: false,
  },
  {
    label: '14点',
    value: 14,
    disabled: false,
  },
  {
    label: '15点',
    value: 15,
    disabled: false,
  },
  {
    label: '16点',
    value: 16,
    disabled: false,
  },
  {
    label: '17点',
    value: 17,
    disabled: false,
  },
  {
    label: '18点',
    value: 18,
    disabled: false,
  },
  {
    label: '19点',
    value: 19,
    disabled: false,
  },
  {
    label: '20点',
    value: 20,
    disabled: false,
  },
  {
    label: '21点',
    value: 21,
    disabled: false,
  },
  {
    label: '22点',
    value: 22,
    disabled: false,
  },
  {
    label: '23点',
    value: 23,
    disabled: false,
  },
  {
    label: '24点',
    value: 24,
    disabled: false,
  },
];
let id = 1;
export default {
  name: 'selectGroup',
  props: ['disabled', 'quantumTime', 'dictData', 'dictKey', 'dictValue', 'type', 'people'],
  data() {
    return {
      ruleForm: {
        startTime: '',
        endTime: '',
      },
      group: '',
      peoples: [],
      show: true,

      time: [],
      options: dictTime,
      endOptions: [],
      rules: {
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
        group: [{ required: true, message: '最多只能选择100个人！', trigger: 'blur' }],
      },
    };
  },
  //   beforeCreate(){
  //     console.log('beforeCreate')
  //   },
  created() {
    this.show = false;
    dictTime = this.dictData;
    if (!this.people) {
      return;
    }
    this.resetDictdata();

    this.people = this.people.split(',');
    let people = [];
    for (let i = 0; i < this.people.length; i++) {
      let arr = this.dictData.filter((item, index, arr) => {
        if (item.id == this.people[i]) {
          arr[index].disabled = true;
        }
        return item.id == this.people[i];
      });
      people.push(arr[0]);
    }
    this.peoples = people;
  },
  watch: {
    people() {
      let people = [];

      this.resetDictdata();
      for (let i = 0; i < this.people.length; i++) {
        let arr = this.dictData.filter((item, index, arr) => {
          if (item.id == this.people[i]) {
            arr[index].disabled = true;
          }
          return item.id == this.people[i];
        });
        people.push(arr[0]);
      }
      this.peoples = people;
    },
    quantumTime() {
      let container = [];
      for (var i = 0; i < this.quantumTime.length; i++) {
        var obj = {};
        obj.time = this.quantumTime[i].start + '~' + this.quantumTime[i].end;
        var startTime = this.quantumTime[i].start.slice(0, 2);
        var endTime = this.quantumTime[i].end.slice(0, 2);
        obj.startTime = Number(startTime);
        obj.endTime = Number(endTime);
        for (var j = obj.startTime; j < obj.endTime; j++) {
          dictTime[j].disabled = true;
        }
        container.push(obj);
      }
      this.time = container;
    },
  },
  methods: {
    // 重置数据
    reset() {
      for (var i = 0; i < dictTime.length; i++) {
        dictTime[i].disabled = false;
      }
      this.time = [];
    },
    resetDictdata() {
      this.dictData.filter((currentValue, index, arr) => {
        arr[index].disabled = false;
      });
      this.peoples = [];
    },
    //   删除添加的时间
    handleClose(tag, index) {
      this.time.splice(index, 1);

      for (var i = tag.startTime; i < tag.endTime; i++) {
        dictTime[i].disabled = false;
      }
    },
    //删除班组人员
    handleCloseGroup(tag, index, id) {
      this.peoples.splice(index, 1);
      this.byValue(this.peoples);
      this.dictData.filter((currentValue, index, arr) => {
        if (currentValue.id == id) {
          arr[index].disabled = false;
        }
      });
    },
    changePeople(val) {
      if (this.peoples.length >= 100) {
        this.ruleForm.group = '';
        this.$refs['ruleForm'].validate((valid) => {
          return false;
        });
        this.$message({
          message: '最多只能选择100个人！',
          type: 'warning',
        });
        return;
      }
      let arr = [];
      let peoples = [];
      this.ruleForm.group = '';
      let self = this;
      arr = this.dictData.filter((currentValue, index, arr) => {
        if (currentValue.id == val[0]) {
          arr[index].disabled = true;
          console.log(currentValue);
        }

        return currentValue.id == val[0];
      });
      this.peoples.push(arr[0]);
      this.byValue(this.peoples);

      // this.peoples = peoples;
    },
    addPeople(formName) {
      console.log(this.ruleForm.group);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.show = false;

          this.byValue(this.group);
        } else {
          return false;
        }
      });
    },
    //   添加时间段
    addTime(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.processTime();
          for (var i = Number(this.ruleForm.startTime); i < Number(this.ruleForm.endTime); i++) {
            dictTime[i].disabled = true;
          }
          this.ruleForm.startTime = '';
          this.ruleForm.endTime = '';
          this.show = false;
          // var time = "";
          // for(var i = 0;i<this.time.length;i++){
          //   time += this.time[i].time
          // }
          this.byValue(this.time);
        } else {
          return false;
        }
      });
    },
    byValue(data) {
      this.$emit('getData', data);
    },
    processTime() {
      var obj = {};
      obj.time =
        this.formatting(this.ruleForm.startTime) + '~' + this.formatting(this.ruleForm.endTime);
      obj.startTime = Number(this.ruleForm.startTime);
      obj.endTime = Number(this.ruleForm.endTime);
      this.time.push(obj);
    },
    formatting(time) {
      if (time < 10) {
        time = '0' + time;
      }
      return time + ':00';
    },
    //   获取结束时间下拉框数据
    getEndOption(node) {
      const nodes = [];
      node += 1;
      for (var i = node; i <= 24; i++) {
        nodes[i] = {};
        nodes[i].label = `${i}点`;
        nodes[i].value = i;
        nodes[i].disabled = false;
        nodes[i].level = false;
        if (dictTime[i].disabled == true) {
          break;
        }
      }
      this.endOptions = nodes.splice(node);
    },
    selectRoom2(item) {
      this.$emit('select', item);
    },
  },
};
</script>

<style scoped>
.box {
  width: 200px;
  margin: 0 15px;
  /* padding: 20px; */
}
.add {
  position: relative;
  display: inline-block;
}
.select {
  display: flex;
  justify-content: space-between;
}
.select-people {
  display: flex;
  justify-content: space-around;
}
.button {
  text-align: right;
  margin-top: 30px;
}
</style>
